import { gql } from 'react-apollo';
import { basic } from '../../../../graphql/fragments/church';

export const getChurchBasicInfo = gql`
    query getChurcheBasicInfo {
      current_user {
        id
        church {
          ...basicChurchFields
        }
      }
    }

    ${basic}
`;

export const getChurchesBasicInfo = gql`
  query getChurchesBasicInfo {
    current_user {
      id
      churches {
        edges {
          node {
            ...basicChurchFields
          }
        }
      }
    }
  }
  
  ${basic}
`;



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/queries/churches.js